export function Users() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Users</h2>
      <p className="text-gray-600">User management UI — to be implemented in Phase 4.</p>
    </div>
  );
}